import React from "react";

export const CardBerandaAbsensi = () => {
  return (
    <div>
      {/* <div className="row">
        <div className="col-3">
          <div className="card-ss">
            <div className="card-header-ss p-3 bg-primary text-white fw-extrabold">
              Hadir
            </div>
            <div className="card-body text-center fw-extrabold">
              <p>Guru</p>
              <h3 className="text-primary">100 / 120</h3>
              <p>Siswa</p>
              <h3 className="text-primary">200 / 300</h3>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="card-ss">
            <div className="card-header-ss p-3 bg-primary text-white fw-extrabold">
              Sakit
            </div>
            <div className="card-body text-center fw-extrabold">
              <p>Guru</p>
              <h3 className="text-primary">4</h3>
              <p>Siswa</p>
              <h3 className="text-primary">7</h3>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="card-ss">
            <div className="card-header-ss p-3 bg-primary text-white fw-extrabold">
              Izin
            </div>
            <div className="card-body text-center fw-extrabold">
              <p>Guru</p>
              <h3 className="text-primary">3</h3>
              <p>Siswa</p>
              <h3 className="text-primary">2</h3>
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="card-ss">
            <div className="card-header-ss p-3 bg-primary text-white fw-extrabold">
              Alpa
            </div>
            <div className="card-body text-center fw-extrabold">
              <p>Guru</p>
              <h3 className="text-primary">0</h3>
              <p>Siswa</p>
              <h3 className="text-primary">2</h3>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
